import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
//import './registerServiceWorker'
import router from './router'
import store from './store'
import api, { initInterceptors } from './api/api'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import VueGtag from 'vue-gtag'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { idLogin, readFromRedis, verifyIntegrationUrl } from './api/integration'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faMoneyBill,
  faBuildingColumns,
  faChartLine,
  faGear,
  faChevronRight,
  faChevronDown,
  faXmark,
  faFilter,
  faUser,
  faHeart,
  faArrowRight,
  faEllipsis,
  faPencil,
  faTrash,
  faBookmark,
  faCheck,
  faBoltLightning,
  faGaugeSimpleHigh,
  faHandHoldingHeart,
  faUserShield,
  faDiagramSuccessor,
  faChalkboardUser,
  faObjectGroup,
  faPen,
  faTrashCan,
  faPlus,
  faSeedling,
  faGaugeHigh,
  faGears,
  faBriefcase,
  faScrewdriverWrench,
  faUserTie,
  faGlobe,
  faComputer,
  faBuilding,
  faNetworkWired,
  faIndustry,
  faTruck,
  faChartGantt,
  faArrowUp,
  faArrowDown,
  faDownload,
  faEnvelope
} from '@fortawesome/free-solid-svg-icons'
import { faBookmark as farBookmark, faNewspaper as farNewspaper } from '@fortawesome/free-regular-svg-icons'

// add icons to use
library.add(
  faMoneyBill,
  faBuildingColumns,
  faChartLine,
  faGear,
  faChevronRight,
  faXmark,
  faFilter,
  faUser,
  faHeart,
  faArrowRight,
  faEllipsis,
  faPencil,
  faTrash,
  faBookmark,
  farBookmark,
  faCheck,
  faBoltLightning,
  faGaugeSimpleHigh,
  faHandHoldingHeart,
  farNewspaper,
  faUserShield,
  faDiagramSuccessor,
  faChalkboardUser,
  faObjectGroup,
  faPen,
  faTrashCan,
  faPlus,
  faSeedling,
  faGaugeHigh,
  faGears,
  faBriefcase,
  faScrewdriverWrench,
  faUserTie,
  faGlobe,
  faComputer,
  faBuilding,
  faNetworkWired,
  faIndustry,
  faTruck,
  faChartGantt,
  faChevronDown,
  faArrowUp,
  faArrowDown,
  faDownload,
  faEnvelope
)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.filter('toCurrency', function(value) {
  if (typeof value !== 'number') {
    return value
  }
  // eslint-disable-next-line no-unused-vars
  var formatter = new Intl.NumberFormat('hu-HU', {
    style: 'currency',
    currency: 'HUF',
    minimumFractionDigits: 0
  })
  return value.toLocaleString('hu-HU')
})

// do not render the app until getMe returns and decides if the user is logged in
// doing otherwise would create unnecessary flickering
const createApp = async () => {
  try {
    // check url contains signature
    var url = new URL(window.location.href)
    var signatureParam = url.searchParams.get('signature')
    if (signatureParam) {
      const isVerified = await verifyIntegrationUrl(url.toString())
      if (isVerified) {
        const userId = await readFromRedis(signatureParam)
        await idLogin(userId)
      }
    }

    await store.dispatch('getMe')
  } catch (err) {
    console.log('Was unable to fetch initial user!')
  }

  const socialConfig = {
    facebookClientId: window._env_.VUE_APP_FACEBOOK_CLIENT_ID,
    googleClientId: window._env_.VUE_APP_GOOGLE_CLIENT_ID,
    linkedInClientId: window._env_.VUE_APP_LINKEDIN_CLIENT_ID
  }

  initInterceptors(store)

  Vue.use(VueReCaptcha, { siteKey: window._env_.VUE_APP_GOOGLE_RECAPTCHA_V3_PUBLIC })
  Vue.use(VueGtag, {
    config: { id: window._env_.VUE_APP_GOOGLE_ANALYTICS_ID }
  })
  Vue.use(VueAxios, api)
  Vue.use(VueAuthenticate, {
    providers: {
      linkedin: {
        name: 'linkedin',
        url: '/api/v1/user/auth/linkedin',
        clientId: socialConfig.linkedInClientId,
        authorizationEndpoint: 'https://www.linkedin.com/oauth/v2/authorization',
        redirectUri: window.location.origin + '/register',
        requiredUrlParams: ['state', 'scope'],
        scope: ['r_emailaddress', 'r_liteprofile'],
        scopeDelimiter: ' ',
        state: 'STATE',
        oauthType: '2.0',
        popupOptions: { width: 527, height: 582 }
      },
      linkedinLog: {
        name: 'linkedinLog',
        url: '/api/v1/user/auth/login/linkedin',
        clientId: socialConfig.linkedInClientId,
        authorizationEndpoint: 'https://www.linkedin.com/oauth/v2/authorization',
        redirectUri: window.location.origin + '/login',
        requiredUrlParams: ['state', 'scope'],
        scope: ['r_emailaddress', 'r_liteprofile'],
        scopeDelimiter: ' ',
        state: 'STATE',
        oauthType: '2.0',
        popupOptions: { width: 527, height: 582 }
      },
      google: {
        name: 'google',
        url: '/api/v1/user/auth/google',
        clientId: socialConfig.googleClientId,
        authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
        redirectUri: window.location.origin + '/register',
        requiredUrlParams: ['scope', 'prompt'],
        optionalUrlParams: ['display'],
        scope: ['profile', 'email'],
        scopePrefix: 'openid',
        scopeDelimiter: ' ',
        display: 'popup',
        oauthType: '2.0',
        popupOptions: { width: 452, height: 633 },
        prompt: 'select_account'
      },
      googleLog: {
        name: 'googleLog',
        url: '/api/v1/user/auth/login/google',
        clientId: socialConfig.googleClientId,
        authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
        redirectUri: window.location.origin + '/login',
        requiredUrlParams: ['scope', 'prompt'],
        optionalUrlParams: ['display'],
        scope: ['profile', 'email'],
        scopePrefix: 'openid',
        scopeDelimiter: ' ',
        display: 'popup',
        oauthType: '2.0',
        popupOptions: { width: 452, height: 633 },
        prompt: 'select_account'
      },
      facebook: {
        name: 'facebook',
        url: '/api/v1/user/auth/facebook',
        clientId: socialConfig.facebookClientId,
        authorizationEndpoint: 'https://www.facebook.com/v2.5/dialog/oauth',
        redirectUri: window.location.origin + '/register',
        requiredUrlParams: ['scope', 'display'],
        scope: ['email'],
        scopeDelimiter: ',',
        display: 'popup',
        oauthType: '2.0',
        popupOptions: { width: 452, height: 633 }
      },
      facebookLog: {
        name: 'facebookLog',
        url: '/api/v1/user/auth/login/facebook',
        clientId: socialConfig.facebookClientId,
        authorizationEndpoint: 'https://www.facebook.com/v2.5/dialog/oauth',
        redirectUri: window.location.origin + '/register',
        requiredUrlParams: ['scope', 'display'],
        scope: ['email'],
        scopeDelimiter: ',',
        display: 'popup',
        oauthType: '2.0',
        popupOptions: { width: 452, height: 633 }
      }
    }
  })

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

createApp()
  .then(() => {
    console.log('App created!')
  })
  .catch(err => console.log('App creation failed', err))
